import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(AuthService)
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Check if the current path contains 'admin'
                    const currentUrl = state.url;
                    const redirectPath = currentUrl.includes('admin') ? '/admin/sign-in' : '/sign-in';
                    
                    // Create URL tree with redirect URL as query parameter
                    const urlTree = router.parseUrl(redirectPath);
                    urlTree.queryParams['redirectUrl'] = currentUrl;
                    
                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
